export const CssSwiper = {
  "& .radiusWithNoCurrencyBar .swiper-pagination.swiper-pagination-horizontal, & .radiusWithCurrencyBar .swiper-pagination.swiper-pagination-horizontal":
    {
      bottom: "12px",
    },
  "@media only screen and (min-width: 576px)": {
    "& .radiusWithNoCurrencyBar .swiper-pagination.swiper-pagination-horizontal, & .radiusWithCurrencyBar .swiper-pagination.swiper-pagination-horizontal":
      {
        bottom: "18px",
      },
  },
  "& .radiusWithNoCurrencyBar .swiper-pagination-bullet, & .radiusWithCurrencyBar .swiper-pagination-bullet":
    {
      backgroundColor: "#3c3c3b",
      opacity: "0.6",
    },
  "& .radiusWithNoCurrencyBar .swiper-pagination-bullet.swiper-pagination-bullet-active, & .radiusWithCurrencyBar .swiper-pagination-bullet.swiper-pagination-bullet-active":
    {
      backgroundColor: "#25b4bd",
      opacity: "0.6",
    },
  "@media only screen and (min-width: 1025px)": {
    "& .radiusWithNoCurrencyBar": {
      borderRadius: "8px",
    },
    "& .radiusWithCurrencyBar": {
      borderRadius: "0x 8px 8px 0px",
    },
  },
};
